<template>
  <div :title="title">
    <div 
        class="display-flex wg-fb-main" 
        :style="{ backgroundColor: bgColor,width:dimension.width,height:dimension.height }"
        @click="mainClick">
      <img :style="{width:imgDimension.width,height:imgDimension.height}" :src="icon">
      <template v-if="actions && actions.length">
        <div 
            v-for="(action, index) in actions"
            :key="'action-'+index"
            class="wg-fb-action">
        </div>
      </template>
    </div>
  </div>
</template> 

<script>
export default {
  props: {
    position: {
      type: Object,
      default: () => {
        return {
          bottom: '30px',
          right: '30px'
        }
      }
    },
    dimension: {
      type: Object,
      default: () => {
        return {
          width: '50px',
          height: '50px'
        }
      }
    },
    imgDimension: {
      type: Object,
      default: () => {
        return {
          width: '24px',
          height: '24px'
        }
      }
    },
    click: {
      type: Function,
      default: () => {}
    },
    icon: String,
    title: String,
    bgColor: {
      type: String,
      default: "#90A4AE"
    },
    /**
     * Nel caso in cui vengano passate ulteriori opzioni di visualizzazione,
     * il pulsante, al click, mediante un'animazione si dividerà per mostrare le altre
     * opzioni inserite (che sono rappresentati mediante oggetti con icona, title, colore di bg e click fn)
     */
    actions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  computed: {
    hasToOpen() {
      return this.actions && this.actions.length;
    }
  },
  methods: {
    /**
     * Dipendentemente da this.click e this.hasToOpen determina cosa accade al click
     * dell'icona principale
     */
    mainClick() {
      if(this.hasToOpen) {
        // Ignoro un eventuale funzione click passata in ingresso

      } else {
        this.click();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.wg-fb-main {
  position: relative;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  box-shadow: 0px 2px 5px #666;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
  &.small {
    width: 34px;
    height: 34px;
  }
}
.wg-fb-main img {
  margin-top: 1px;
}
.wg-fb-action {
  position: absolute;
  
}
// Animazione pulsante

</style>
